<template>
  <div class='uerPage'>
    <el-tabs v-model="activeUserType" type="card" @tab-click="handleTabChange">
      <el-tab-pane :label="$t('account_redesign.personal_account')" name="PERSONAL">
        <div class="rightHeader">
          <v-search :formContent='personalFormContent' :SearchForm='SearchForm' :inline='true' :optareBtn='optareBtn'
                    @resetFn='resetFn' @confirmFn='getListFn' @searchFn='getListFn' @addFn='addFn' @enableFn='enableFn' @disableFn='disableFn'>
          </v-search>
        </div>
        <div class='componentPage'>
          <TablePage :loading='loading' :tableData='tableData' :activeUserType='activeUserType'
                     @editFn='editFn' @choozeTableFn='choozeTableFn' @againFn='againFn' @handleSelectionChange='handleSelectionChange' />
          <Pagination class='pagination' :total='total' :page.sync='SearchForm.iDisplayStart'
                      :limit.sync='SearchForm.iDisplayLength' @pagination='getListFn'></Pagination>
        </div>
      </el-tab-pane>
      <el-tab-pane :label="$t('account_redesign.enterprise_account')" name="ENTERPRISE_ROOT">
        <div class="rightHeader">
          <v-search :formContent='enterpriseFormContent' :SearchForm='SearchForm' :inline='true' :optareBtn='optareBtn'
                    @resetFn='resetFn' @confirmFn='getListFn' @searchFn='getListFn' @addFn='addFn' @enableFn='enableFn' @disableFn='disableFn'>
          </v-search>
        </div>
        <div class='componentPage'>
          <TablePage :loading='loading' :tableData='tableData' :activeUserType='activeUserType'
                     @editFn='editFn' @choozeTableFn='choozeTableFn' @againFn='againFn' @handleSelectionChange='handleSelectionChange' />
          <Pagination class='pagination' :total='total' :page.sync='SearchForm.iDisplayStart'
                      :limit.sync='SearchForm.iDisplayLength' @pagination='getListFn'></Pagination>
        </div>
      </el-tab-pane>
    </el-tabs>

    <!-- 新增/编辑（单页表单，初始账号无需向导） -->
    <AccountFormDialog :isShow.sync='isShowAccountForm' :statusArray='statusArray'
                       :activeUserType='activeUserType' :customerArray='customerArray'
                       :editObj='editObj' />

    <!-- 详情 -->
    <detailDialog ref='detail' :isShowDetail.sync='isShowDetail' :title='title' :detailObj='detailObj'
                  :detaiilLoad='detaiilLoad' :customerArrayDetail='customerArrayDetail' :roleArray='roleArray'
                  :roleTypeArray='roleTypeArray' :StructureArray='StructureArray' :statusArray='statusArray' />

    <!-- 重新邀请成功弹窗 -->
    <modal
        :title="reinviteDialogTitle"
        :visible.sync="reinviteSuccessVisible"
        width="600px"
        :close-on-click-modal="false"
        append-to-body
    >
        <div class="success-dialog-body">
            <p class="success-body-text">{{ $t('account_redesign.reinvite_success_body') }}</p>
            <p class="success-warning-text">{{ $t('account_redesign.success_create_warning') }}</p>
            <p class="success-choose-text">{{ $t('account_redesign.success_create_choose') }}</p>
            <p class="success-desc-text">{{ $t('account_redesign.success_create_csv_desc') }}</p>
            <p class="success-desc-text">{{ $t('account_redesign.success_create_show_desc') }}</p>
            <div v-if="passwordVisible" class="password-display">
                <span class="password-label">{{ $t('account_redesign.csv_password') }}：</span>
                <span class="password-value">{{ reinvitePassword }}</span>
            </div>
            <p class="success-security-text">{{ $t('account_redesign.success_create_security') }}</p>
            <p class="success-warning-text">{{ $t('account_redesign.success_create_48h_warning') }}</p>
        </div>
        <div slot="footer">
            <el-button type="primary" @click="downloadReinviteCsv">{{ $t('account_redesign.download_csv_file') }}</el-button>
            <el-button type="primary" @click="passwordVisible = !passwordVisible">{{ passwordVisible ? $t('account_redesign.hide_password') : $t('account_redesign.show_password') }}</el-button>
            <el-button type="primary" @click="reinviteSuccessVisible = false">{{ $t('account_redesign.close') }}</el-button>
        </div>
    </modal>

  </div>
</template>

<script>
import mixinForm from '@/utils/formMixins.js'
import publicMix from '@/utils/public.js'
import getRangeMin from '@/utils/getRange.js'
import {
  accountCustomer,
  accountDetail,
  accountList,
  accountRemove,
  accountRole,
  accountStructure
} from '@/api/modules/userInfo.js'
import { reinviteSubAccount, batchUpdateStatus } from '@/api/modules/account.js'
import TablePage from './components/Table.vue'
import AccountFormDialog from './components/AccountFormDialog.vue'
import detailDialog from './components/detailDialog.vue'

export default {
  mixins: [mixinForm, publicMix, getRangeMin],

  components: {
    TablePage,
    AccountFormDialog,
    detailDialog
  },

  data () {
    return {
      // 当前激活的 Tab：PERSONAL / ENTERPRISE_ROOT
      activeUserType: 'PERSONAL',
      SearchForm: {
        customerId: null,
        account: null,
        name: null,
        status: null,
        type: null,
        userType: 'PERSONAL',
        iDisplayStart: 0,
        iDisplayLength: 15
      },
      optareBtn: [
        {
          id: 1,
          icon: '',
          vHas: ['incubatorAddCarrier'],
          text: 'public.btn_new',
          method: 'addFn'
        },
        {
          id: 2,
          icon: '',
          text: 'account_redesign.batch_enable',
          method: 'enableFn'
        },
        {
          id: 3,
          icon: '',
          text: 'account_redesign.batch_disable',
          method: 'disableFn'
        }
      ],
      statusIconArray: {
        1: { icon: 'el-icon-warning' },
        0: { icon: 'el-icon-warning-outline' }
      },
      roleIconArray: {
        '-1': { icon: 'el-icon-user-solid' },
        0: { icon: 'el-icon-user' },
        1: { icon: 'el-icon-s-custom' },
        2: { icon: 'el-icon-s-check' },
        3: { icon: 'el-icon-headset' }
      },

      // 新增 & 编辑
      isShowAccountForm: false,
      editObj: null,
      roleTypeArray: [],
      // 4 种状态 + Please Select（搜索栏用）
      statusArray: [
        { value: '', label: 'public.please', icon: 'el-icon-thumb' },
        { value: 1, label: 'account_redesign.enable', icon: 'el-icon-circle-check', color: '#67c23a' },
        { value: 0, label: 'account_redesign.disable', icon: 'el-icon-circle-close', color: '#f56c6c' },
        { value: 2, label: 'account_redesign.pending', icon: 'el-icon-time', color: '#e6a23c' },
        { value: 3, label: 'account_redesign.expire', icon: 'el-icon-lock', color: '#909399' }
      ],
      // WizardDialog 用的 statusArray（不含 Please Select）
      wizardStatusArray: [
        { value: 1, label: 'account_redesign.enable' },
        { value: 0, label: 'account_redesign.disable' },
        { value: 2, label: 'account_redesign.pending' },
        { value: 3, label: 'account_redesign.expire' }
      ],
      customerArray: [],
      // 详情
      isShowDetail: false,
      detaiilLoad: false,
      detailObj: {},
      // 客户
      customerArrayDetail: [],
      // 角色
      roleArray: [],
      // 代理管辖
      prxyArray: [],
      // 架构
      StructureArray: [],
      // 表格操作
      choozeTable: [],
      // 重新邀请成功弹窗
      reinviteSuccessVisible: false,
      reinvitePassword: '',
      reinviteAccount: '',
      reinviteCustomerId: '',
      reinviteUserType: '',
      passwordVisible: false,
      // 批量操作选中的行
      selectedRows: []
    }
  },
  computed: {
    // 重新邀请成功弹窗标题：根据当前 Tab 区分
    reinviteDialogTitle () {
      return this.activeUserType === 'PERSONAL'
        ? this.$t('account_redesign.personal_reinvited_title')
        : this.$t('account_redesign.enterprise_reinvited_title')
    },
    // 个人账号搜索条件：Account / Display Name / Status
    personalFormContent () {
      return [
        { id: 1, text: 'user.account', type: 'input', paramsName: 'account', isChooze: true },
        { id: 2, text: 'user.name', type: 'input', paramsName: 'name', isChooze: false },
        { id: 3, text: 'user.status', type: 'select', paramsName: 'status', selectParam: this.statusArray, isChooze: false }
      ]
    },
    // 企业账号搜索条件：Account / Display Name / Status / Company（下拉）
    enterpriseFormContent () {
      const base = [
        { id: 1, text: 'user.account', type: 'input', paramsName: 'account', isChooze: true },
        { id: 2, text: 'user.name', type: 'input', paramsName: 'name', isChooze: false },
        { id: 3, text: 'user.status', type: 'select', paramsName: 'status', selectParam: this.statusArray, isChooze: false }
      ]
      // 平台管理员才显示 Company 下拉
      if (this.$store.state.type === 3 || this.$store.state.type === 2) {
        base.push({ id: 4, text: 'public.table_scope', type: 'select', paramsName: 'customerId', selectParam: this.customerArray, isChooze: false })
      }
      return base
    }
  },
  created () {
    this.getRoleTypeFn()
    this.getCustomer()
  },
  methods: {
    handleTabChange () {
      // 切换 Tab 时重置搜索条件并按 userType 过滤
      this.SearchForm.userType = this.activeUserType
      this.SearchForm.account = null
      this.SearchForm.name = null
      this.SearchForm.status = null
      this.SearchForm.customerId = null
      this.SearchForm.iDisplayStart = 0
      this.getListFn()
    },
    resetFn () {
      this.SearchForm = {
        customerId: null,
        account: null,
        name: null,
        status: null,
        type: null,
        userType: this.activeUserType,
        iDisplayStart: 0,
        iDisplayLength: 15
      }
      this.getListFn()
    },
    getListFn () {
      this.loading = true
      // 强制设置 userType 为当前 Tab
      this.SearchForm.userType = this.activeUserType
      accountList(this.SearchForm)
        .then(({
          result,
          pageInfo
        }) => {
          this.tableData = result
          this.total = pageInfo.total
          this.loading = false
        })
        .finally(() => {
          this.loading = false
        })
    },
    /** 表格勾选 */
    handleSelectionChange (rows) {
      this.selectedRows = rows
    },
    /** 批量启用 */
    enableFn () {
      this.batchUpdateStatusFn(1, 'account_redesign.batch_enable_tip')
    },
    /** 批量禁用 */
    disableFn () {
      this.batchUpdateStatusFn(0, 'account_redesign.batch_disable_tip')
    },
    /** 批量修改状态通用方法 */
    batchUpdateStatusFn (status, tipKey) {
      if (!this.selectedRows || this.selectedRows.length === 0) {
        this.$message.warning(this.$t('account_redesign.batch_select_empty'))
        return
      }
      this.$confirm(this.$t(tipKey), this.$t('public.prompt'), {
        confirmButtonText: this.$t('public.btn_confirm'),
        cancelButtonText: this.$t('public.btn_cancel'),
        type: 'warning'
      })
        .then(() => {
          const userIds = this.selectedRows.map(r => r.id)
          batchUpdateStatus(userIds, status)
            .then((res) => {
              if (res && res.state && res.state.code === 200) {
                this.$message.success(this.$t('user.user_new_code_200'))
                this.getListFn()
              } else {
                this.$message.error((res && res.state && res.state.msg) || this.$t('account_redesign.operate_failed'))
              }
            })
            .catch((e) => {
              const msg = (e && e.response && e.response.data && e.response.data.state && e.response.data.state.msg)
                || (e && e.state && e.state.msg)
                || this.$t('account_redesign.operate_failed')
              this.$message.error(msg)
            })
        })
        .catch(() => {})
    },
    getCustomer () {
      this.getRange('customer', 1).then(({ result }) => {
        this.customerArray = result.map(item => {
          return {
            value: item.id,
            label: item.id === '-1' || item.id === '-2' ? 'public.' + item.name : item.name,
            code: item.code || ''
          }
        })
        this.customerArray.unshift({
          value: null,
          label: 'public.please',
          code: ''
        })
      })
    },
    getInitData (obj, num) {
      this.shareParamFn(obj).then(({ result }) => {
        this.statusArray = this.changeIn18Data(result, this.statusIconArray)
      })
    },
    changeIn18Data (result = [], iconArray) {
      const array = [{
        value: '',
        label: 'public.please',
        icon: 'el-icon-thumb'
      }]
      return array.concat(
        result.map((item, index) => {
          return {
            value: parseInt(item.code),
            label: 'public.' + item.content,
            icon: iconArray[item.code].icon
          }
        })
      )
    },
    getRoleTypeFn () {
      this.getRoleType().then(({ result }) => {
        this.roleTypeArray = this.changeIn18Data(result, this.roleIconArray)
      })
    },
    /** 新增 */
    addFn () {
      this.editObj = null
      this.isShowAccountForm = true
    },
    /** 编辑 */
    editFn (row) {
      this.editObj = { ...row }
      this.isShowAccountForm = true
    },
    /** 删除 */
    DelFn () {
      if (this.choozeTable.length === 0) return this.$message.warning(this.$t('public.least_one_data'))
      const ids = this.choozeTable.map(item => item.id).join(',')
      this.TODOTIPDEL(ids)
    },
    delFn (row) {
      this.TODOTIPDEL(row.id)
    },
    /** 勾选表格 */
    choozeTableFn (array) {
      this.choozeTable = array
    },
    /**
     *
     * @param {*param 选中数据id} param string
     */
    TODOTIPDEL (param) {
      this.$confirm(this.$t('user.tip_before_delete'), this.$t('public.prompt'), {
        confirmButtonText: this.$t('public.btn_confirm'), // 确定按钮的文案
        cancelButtonText: this.$t('public.btn_cancel'), // 取消按钮的文案
        type: 'warning'
      })
        .then(() => {
          accountRemove({ id: param }).then(({ result }) => {
            if (result === 200) {
              this.getListFn()
              this.$message.success(this.$t('public.tip_del_succ').toString())
            } else {
              this.$message.error('public.tip_del_fail')
            }
          })
        })
        .catch(() => {
        })
    },
    /** 详情 */
    async detailFn (row) {
      this.isShowDetail = true
      this.detaiilLoad = true
      this.title = this.$t('user.account_info')

      this.$nextTick(() => {
        this.$refs.detail.ismode = true
      })

      const res = await accountDetail({ id: row.id })
      this.detailObj = res.result
      const {
        roleType,
        customerId,
        id,
        scopeId
      } = res.result
      // 选择角色类型 -> 客户（默认提取第一条数据，如果为代理角色客户隐藏） -> 角色（默认提取第一条数据）-> 架构
      if (roleType !== -1) {
        const { result } = await accountCustomer({ type: roleType })
        this.customerArrayDetail = result
      }
      // 角色
      const { result } = await accountRole({
        type: roleType,
        customerId: roleType === -1 ? null : customerId
      })
      this.roleArray = result

      // this.prxyArray = result;
      let param = ''
      if (roleType === -1) {
        param = 'scope'
      } else {
        param = 'customerId'
      }

      const query = {
        type: roleType,
        [param]: customerId,
        scope: scopeId || null,
        isEdit: 0,
        id: id
      }
      const treeData = await accountStructure(query)
      this.StructureArray = treeData.result.item
      this.detaiilLoad = false
    },
    /** 重新邀请（重新初始化密码，首次登录需改密码） */
    againFn (row) {
      this.$confirm(this.$t('account_redesign.tip_reinvite'), this.$t('account_redesign.reinvite'), {
        confirmButtonText: this.$t('public.btn_confirm'),
        cancelButtonText: this.$t('public.btn_cancel'),
        type: 'warning'
      })
        .then(() => {
          reinviteSubAccount(row.id)
            .then((res) => {
              if (res && res.state && res.state.code === 200) {
                const result = res.result || {}
                // 兼容 snake_case（后端 @SnakeCaseResponse 返回 initial_password）
                this.reinvitePassword = result.initialPassword || ''
                this.reinviteAccount = row.account || ''
                this.reinviteCustomerId = row.customerId || ''
                // 记录当前重新邀请的账号类型，用于 CSV URL 生成
                this.reinviteUserType = row.userType || this.activeUserType || 'ENTERPRISE'
                this.passwordVisible = false
                this.reinviteSuccessVisible = true
                this.getListFn()
              } else {
                this.$message.error((res && res.state && res.state.msg) || this.$t('account_redesign.reinvite_failed'))
              }
            })
            .catch((e) => {
              console.error('reinvite error:', e)
              const msg = (e && e.response && e.response.data && e.response.data.state && e.response.data.state.msg)
                || (e && e.data && e.data.state && e.data.state.msg)
                || (e && e.state && e.state.msg)
                || this.$t('account_redesign.reinvite_failed')
              this.$message.error(msg)
            })
        })
        .catch(() => {
        })
    },
    /** 下载重新邀请的 CSV */
    downloadReinviteCsv () {
      let loginUrl = window.location.origin + '/login'
      // Enterprise Root 账号：带 mode=root，直接进入企业 Tab + Root 登录模式（无需 Company ID）
      // Personal 账号：不带参数，默认个人 Tab
      if (this.reinviteUserType === 'ENTERPRISE_ROOT' || this.reinviteUserType === 'ENTERPRISE') {
        loginUrl += '?mode=root'
      }
      const header = `${this.$t('account_redesign.csv_username')},${this.$t('account_redesign.csv_password')},${this.$t('account_redesign.csv_login_url')}`
      const row = `${this.reinviteAccount},${this.reinvitePassword},${loginUrl}`
      const csvContent = header + '\n' + row
      const blob = new Blob(['\ufeff' + csvContent], { type: 'text/csv;charset=utf-8;' })
      const link = document.createElement('a')
      link.href = URL.createObjectURL(blob)
      link.download = `account_${this.reinviteAccount}.csv`
      link.click()
      URL.revokeObjectURL(link.href)
    }
  }
}
</script>

<style lang='scss' scoped>
.uerPage {
  display: flex;
  flex-direction: column;
  height: 100%;
  width: 100%;
  padding: 10px 15px 0 15px;
  box-sizing: border-box;

  // el-tabs 需要撑满剩余高度，使内部 .componentPage 的 flex:1 生效
  // 解决首次进入时 el-table 高度计算为 0 只显示两行的问题
  ::v-deep .el-tabs {
    flex: 1;
    overflow: hidden;
    display: flex;
    flex-direction: column;

    .el-tabs__content {
      flex: 1;
      overflow: hidden;

      .el-tab-pane {
        height: 100%;
        display: flex;
        flex-direction: column;
      }
    }
  }

  .rightHeader {
    position: relative;
    flex-shrink: 0;
  }

  .componentPage {
    flex: 1;
    overflow: auto;

    .pagination {
      padding-top: 0;
      padding-right: 15px !important;
      display: flex;
      align-items: center;
      justify-content: flex-end;
    }
  }
}

/* 重新邀请成功弹窗 */
.success-dialog-body {
  line-height: 1.8;
  .success-body-text {
    font-size: 15px;
    font-weight: bold;
    margin-bottom: 12px;
  }
  .success-warning-text {
    color: #e6a23c;
    font-weight: bold;
    margin-bottom: 12px;
  }
  .success-choose-text {
    margin-bottom: 8px;
  }
  .success-desc-text {
    color: #606266;
    margin-bottom: 4px;
  }
  .password-display {
    margin: 16px 0;
    padding: 10px 16px;
    background: #f0f9eb;
    border: 1px solid #e1f3d8;
    border-radius: 4px;
    .password-label {
      font-weight: bold;
    }
    .password-value {
      font-family: monospace;
      font-size: 16px;
      color: var(--primary-color);
    }
  }
  .success-security-text {
    color: #909399;
    font-size: 13px;
    margin-top: 12px;
  }
}
</style>
